import React, { Component, Fragment } from 'react';
import { Link as LinkTo } from 'react-router-dom';
import { AUTH_TOKEN, USER_ID } from '../constants';
import {
  timeDifferenceForDate,
  repliesFragment,
  stripUrl,
  countRepliesRecursively,
  addUrlRefParam,
  handleUnauthorized,
} from '../utils';
import { Mutation, Query } from 'react-apollo';
import gql from 'graphql-tag';
//import { NEW_VOTES_SUBSCRIPTION, UNVOTES_SUBSCRIPTION } from "./LinkList";
import { VOTE_MUTATION, UNVOTE_MUTATION } from './Link';
import Comment from './Comment';
// import { addReply } from "./ReplyDetails";
// import { removeReply } from "./Reply";

export const LINK_QUERY = gql`
  query LinkQuery($linkId: ID!) {
    link(linkId: $linkId) {
      id
      created
      url
      description
      ranking
      postedBy {
        id
        name
      }
      votes {
        id
        user {
          id
        }
      }
      comments {
        id
        created
        text
        user {
          id
          name
        }
        link {
          id
        }
        votes {
          id
          user {
            id
          }
        }
        ${repliesFragment}
      }
    }
  }
`;

const POST_COMMENT = gql`
  mutation PostComment($commentId: ID!, $text: String!) {
    comment(commentId: $commentId, text: $text) {
      id
      created
      text
      user {
        id
        name
      }
      link {
        id
      }
      votes {
        id
        user {
          id
        }
      }
      ${repliesFragment}
    }
  }
`;

// export const NEW_COMMENTS_SUBSCRIPTION = gql`
//   subscription {
//     newComment {
//       id
//       created
//       text
//       user {
//         id
//         name
//       }
//       link {
//         id
//       }
//       votes {
//         id
//         user {
//           id
//         }
//       }
//       ${repliesFragment}
//     }
//   }
// `;
// export const UNCOMMENT_SUBSCRIPTION = gql`
//   subscription {
//     unComment {
//       id
//     }
//   }
// `;

// export const NEW_REPLIES_SUBSCRIPTION = gql`
//   subscription {
//     newReply {
//       id
//       text
//       created
//       user {
//         id
//         name
//       }
//       comment {
//         id
//       }
//       reply {
//         id
//       }
//       ${repliesFragment}
//     }
//   }
// `;
// export const UNREPLY_SUBSCRIPTION = gql`
//   subscription {
//     unReply {
//       id
//     }
//   }
// `;
const userHasVoted = (link) => {
  const userId = localStorage.getItem(USER_ID);

  return !!link.votes.filter((vote) => {
    return vote.user && vote.user.id === userId;
  }).length;
};

const replyIdExists = (id, replies) => {
  if (replies && replies.some((reply) => reply.id === id)) {
    return true;
  } else if (replies) {
    return replies
      .map((reply) => {
        return replyIdExists(id, reply.replies);
      })
      .some((value) => value === true);
  } else {
    return false;
  }
};

class LinkDetails extends Component {
  state = {
    comment: '',
    isPosting: false,
    isVoting: false,
    error: '',
    // subToComments: false,
    // subToUnComments: false,
    // subToNewVotes: false,
    // subToUnVotes: false,
    // subToReplies: false,
    // subToUnReplies: false,
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history);
  }
  // _subscribeToNewComments = (subscribeToMore) => {
  //   this.setState({
  //     subToComments: true,
  //   });
  //   subscribeToMore({
  //     document: NEW_COMMENTS_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;
  //       const newComment = subscriptionData.data.newComment;
  //       const exists =
  //         prev.link &&
  //         prev.link.comments.find(({ id }) => id === newComment.id);
  //       if (exists) return prev;
  //       return Object.assign({}, prev, {
  //         link: {
  //           comments: [...prev.link.comments, newComment],
  //           __typename: prev.link.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToDeletedComments = (subscribeToMore) => {
  //   this.setState({
  //     subToUnComments: true,
  //   });
  //   subscribeToMore({
  //     document: UNCOMMENT_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;
  //       const deletedComment = subscriptionData.data.unComment;
  //       const exists = prev.link.comments.find(
  //         (comment) => comment.id === deletedComment.id
  //       );
  //       if (!exists) return prev;
  //       return Object.assign({}, prev, {
  //         link: {
  //           comments: prev.link.comments.filter(
  //             (comment) => comment.id !== deletedComment.id
  //           ),
  //           __typename: prev.link.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToReplies = (subscribeToMore) => {
  //   this.setState({
  //     subToReplies: true,
  //   });
  //   subscribeToMore({
  //     document: NEW_REPLIES_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;
  //       const newReply = subscriptionData.data.newReply;
  //       let exists = false;
  //       if (prev.link.comments && prev.link.comments.length) {
  //         prev.link.comments.forEach((comment) => {
  //           if (comment.replies && comment.replies.length) {
  //             exists = replyIdExists(
  //               subscriptionData.data.newReply.id,
  //               comment.replies
  //             );
  //           }
  //         });
  //       }
  //       if (exists) return prev;
  //       const comments = prev.link.comments.map((comment) => {
  //         if (newReply.comment && comment.id === newReply.comment.id) {
  //           if (comment.replies) {
  //             comment.replies.push(newReply);
  //           } else {
  //             comment.replies = [newReply];
  //           }
  //           return comment;
  //         } else if (comment.replies && comment.replies.length) {
  //           return {
  //             ...comment,
  //             replies: addReply(
  //               comment.replies,
  //               newReply,
  //               newReply.comment ? newReply.comment.id : newReply.reply.id
  //             ),
  //           };
  //         } else {
  //           return comment;
  //         }
  //       });
  //       return Object.assign({}, prev, {
  //         link: {
  //           comments,
  //           __typename: prev.link.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToDeletedReplies = (subscribeToMore) => {
  //   this.setState({
  //     subToUnReplies: true,
  //   });
  //   subscribeToMore({
  //     document: UNREPLY_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;
  //       const deletedReply = subscriptionData.data.unReply;
  //       let exists = false;
  //       prev.link.comments.forEach((comment) => {
  //         if (!exists) {
  //           if (comment.replies) {
  //             exists = replyIdExists(deletedReply.id, comment.replies);
  //           }
  //         }
  //       });
  //       if (!exists) return prev;
  //       const comments = prev.link.comments.map((comment) => {
  //         if (comment.replies) {
  //           comment.replies = removeReply(deletedReply.id, comment.replies);
  //         }
  //         return comment;
  //       });
  //       return Object.assign({}, prev, {
  //         link: {
  //           comments,
  //           __typename: prev.link.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToNewVotes = (subscribeToMore) => {
  //   this.setState({
  //     subToVotes: true,
  //   });
  //   subscribeToMore({
  //     document: NEW_VOTES_SUBSCRIPTION,
  //   });
  // };

  // _subscribeToUnVotes = (subscribeToMore) => {
  //   this.setState({
  //     subToUnVotes: true,
  //   });
  //   subscribeToMore({
  //     document: UNVOTES_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;

  //       const deletedVote = subscriptionData.data.unVote;
  //       const exists = prev.link.votes.find(
  //         (vote) => vote.id === deletedVote.id
  //       );
  //       if (!exists) return prev;

  //       return Object.assign({}, prev, {
  //         link: {
  //           id: prev.link.id,
  //           votes: prev.link.votes.filter((vote) => vote.id !== deletedVote.id),
  //           __typename: prev.link.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  _updateCacheAfterVote = (store, voteData) => {
    const data = store.readQuery({
      query: LINK_QUERY,
      variables: { linkId: this.props.match.params.id },
    });
    data.link.votes = voteData.vote
      ? voteData.vote.link.votes
      : data.link.votes.filter((vote) => {
          return vote.id !== voteData.unvote.id;
        });
    store.writeQuery({
      query: LINK_QUERY,
      data,
      variables: { linkId: this.props.match.params.id },
    });
  };

  render() {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    const userId = localStorage.getItem(USER_ID);

    return (
      <Query
        query={LINK_QUERY}
        variables={{
          linkId: this.props.match.params.id,
        }}
      >
        {({ loading, error, data }) => {
          //subscribeToMore
          if (loading)
            return <div className="mt2 animate-flicker">Loading...</div>;
          if (error || !data.link) {
            console.log(error, data);
            return <div className="mt2">Could not fetch link details.</div>;
          }
          const repliesCount = countRepliesRecursively(data.link.comments, 0);
          // if (!this.state.subToComments) {
          //   this._subscribeToNewComments(subscribeToMore);
          // }
          // if (!this.state.subToUnComments) {
          //   this._subscribeToDeletedComments(subscribeToMore);
          // }
          // if (!this.state.subToVotes) {
          //   this._subscribeToNewVotes(subscribeToMore);
          // }
          // if (!this.state.subToUnVotes) {
          //   this._subscribeToUnVotes(subscribeToMore);
          // }
          // if (!this.state.subToReplies) {
          //   this._subscribeToReplies(subscribeToMore);
          // }
          // if (!this.state.subToUnReplies) {
          //   this._subscribeToDeletedReplies(subscribeToMore);
          // }
          return (
            <div className="flex mt2 items-start">
              {authToken &&
              data.link.postedBy &&
              localStorage.getItem(USER_ID) !== data.link.postedBy.id &&
              !userHasVoted(data.link) ? (
                <div className="flex items-center pr1 min-w-s">
                  <Mutation
                    mutation={VOTE_MUTATION}
                    variables={{ linkId: data.link.id }}
                    update={(store, { data }) => {
                      this.setState({
                        ...this.state,
                        isVoting: false,
                      });
                      this._updateCacheAfterVote(store, data);
                    }}
                    onError={(err) => {
                      this.checkUnauthorized(err);
                      this.setState({
                        ...this.state,
                        isVoting: false,
                      });
                    }}
                  >
                    {(voteMutation) => (
                      <div
                        className="ml1 gray f11 upvote"
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            isVoting: true,
                          });
                          voteMutation();
                        }}
                      >
                        {this.state.isVoting ? '' : '▲'}
                      </div>
                    )}
                  </Mutation>
                </div>
              ) : (
                <div className="spacing-sm"></div>
              )}
              <div className="ml1 w-100">
                <a
                  className={`link no-underline show-visited ${
                    data.link.postedBy && data.link.postedBy.id === userId
                      ? 'my-link'
                      : ''
                  }`}
                  href={addUrlRefParam(data.link.url)}
                  target="_blank"
                >
                  {data.link.description}{' '}
                  <span className="f12 gray">({stripUrl(data.link.url)})</span>
                </a>
                <div className="f8pt lh-copy gray pt1">
                  {data.link.votes.length + 1}{' '}
                  {data.link.votes.length + 1 === 1 ? 'point' : 'points'}
                  {' | '}
                  {data.link.postedBy ? (
                    <LinkTo
                      to={`/account/${data.link.postedBy.id}`}
                      className={`ml1 no-underline link ${
                        data.link.postedBy.id === userId ? 'green' : 'gray'
                      }`}
                    >
                      {'by '}
                      {data.link.postedBy.name}
                    </LinkTo>
                  ) : (
                    'by Unknown'
                  )}
                  {' | '}
                  {timeDifferenceForDate(data.link.created)} |
                  {` ${repliesCount} comment` +
                    `${repliesCount === 1 ? '' : 's'}`}
                  {authToken && userHasVoted(data.link) && (
                    <Mutation
                      mutation={UNVOTE_MUTATION}
                      variables={{ linkId: data.link.id }}
                      update={(store, { data }) =>
                        this._updateCacheAfterVote(store, data)
                      }
                      onError={(err) => {
                        this.checkUnauthorized(err);
                      }}
                    >
                      {(voteMutation) => (
                        <Fragment>
                          <span> |</span>
                          <span
                            className="ml1 gray link"
                            onClick={voteMutation}
                          >
                            (unvote)
                          </span>
                        </Fragment>
                      )}
                    </Mutation>
                  )}
                </div>
                {authToken && (
                  <div className="pt3">
                    <div className="textarea-container">
                      <textarea
                        name="comment"
                        rows="6"
                        value={this.state.comment}
                        onChange={(e) =>
                          this.setState({ comment: e.target.value })
                        }
                      ></textarea>
                      <div>{!!this.state.error.length && this.state.error}</div>
                    </div>
                    <div className="pt1">
                      <Mutation
                        mutation={POST_COMMENT}
                        variables={{
                          commentId: data.link.id,
                          userId: localStorage.getItem(USER_ID),
                          text: this.state.comment,
                        }}
                        update={(store, { data: { comment } }) => {
                          this.setState({
                            ...this.state,
                            comment: '',
                            isPosting: false,
                            error: '',
                          });
                          try {
                            const linkData = store.readQuery({
                              query: LINK_QUERY,
                              variables: { linkId: this.props.match.params.id },
                            });
                            linkData.link.comments.push(comment);
                            store.writeQuery({
                              query: LINK_QUERY,
                              data: linkData,
                              variables: { linkId: this.props.match.params.id },
                            });
                          } catch (err) {
                            console.log('No link query in cache to update');
                          }
                          try {
                            // Invalidate the cached feed queries
                            Object.keys(store.data.data).forEach((key) => {
                              key.match(/ROOT_QUERY.feed/) &&
                                store.data.delete(key);
                            });
                          } catch (err) {
                            console.log('No feed query in cache to invalidate');
                          }
                          try {
                            // Invalidate the cached profile queries
                            Object.keys(store.data.data).forEach((key) => {
                              key.match(/ROOT_QUERY.userComments/) &&
                                store.data.delete(key);
                            });
                          } catch (err) {
                            console.log(
                              'No profile query in cache to invalidate',
                            );
                          }
                        }}
                        onError={(err) => {
                          this.checkUnauthorized(err);
                          if (err.graphQLErrors && err.graphQLErrors.length) {
                            this.setState({
                              error: err.graphQLErrors[0],
                              isPosting: false,
                            });
                          } else {
                            this.setState({
                              error:
                                'An error occured when posting the comment',
                              isPosting: false,
                            });
                          }
                        }}
                      >
                        {(postComment) => (
                          <button
                            className="pointer button"
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                isPosting: true,
                              });
                              postComment();
                            }}
                            disabled={this.state.isPosting}
                          >
                            {this.state.isPosting
                              ? 'posting comment'
                              : 'add comment'}
                          </button>
                        )}
                      </Mutation>
                    </div>
                  </div>
                )}
                {!!data.link.comments.length && (
                  <div className="pt3">
                    <div className="label gray pt2 pb2">comments:</div>
                    <div className="">
                      {data.link.comments
                        //.filter(comment => comment.user)
                        .sort((a, b) => b.votes.length - a.votes.length)
                        .map((comment) => {
                          return (
                            <Comment
                              key={comment.id}
                              id={comment.id}
                              user={comment.user}
                              created={comment.created}
                              text={comment.text}
                              replies={comment.replies}
                              linkId={comment.link.id}
                              votes={comment.votes}
                            />
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default LinkDetails;



// WEBPACK FOOTER //
// ./src/components/LinkDetails.js